/* Utility Function - Open and accordions */

/* Trigger Class = "accordion" */
/* Content must be next direct sibling, with the class "accordion__content" */
var accordion = document.getElementsByClassName("accordion");

for (i = 0; i < accordion.length; i++) {
  accordion[i].addEventListener("click", function() {
    var content = this.nextElementSibling;
    this.classList.toggle("open");
    content.classList.toggle("open");

    if (content.style.maxHeight){
      content.style.maxHeight = content.scrollHeight + "px";
      this.dataset.accordionicon = "+"
      setTimeout(() => {
      content.style.maxHeight = null;
      }, 1);
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      this.dataset.accordionicon = "-"
      setTimeout(() => {
        content.style.maxHeight = "none";
      }, 200);
    } 
  });
}

/* Utility Function - Freeze Body */
freezeBodyToggle = (freezeBody) => {
  body = document.querySelector('body');

  if (freezeBody == false) {
    body.classList.remove('freezeBody');
  } else if (freezeBody == true) {
    body.classList.add('freezeBody');
  }
}

/* Handle auto-playing videos after page has loaded. */
window.addEventListener('load', function () {
  document.querySelectorAll('video').forEach((video) => {
    video.play();
  })
})

function initAjaxinate() {
  var endlessScroll = new Ajaxinate({offset: 200, loadingText: 'Loading Products', method: 'click'});
}

/* Parallax Logic */
const movingElements = document.querySelectorAll('.parallax');

function updateParallax() {
  movingElements.forEach(el => {
    const container = el.closest('.parallax-wrapper');
    const containerRect = container.getBoundingClientRect();

    const scrollProgress = (window.innerHeight - containerRect.top) / (window.innerHeight + containerRect.height);
    const clampedProgress = Math.max(0, Math.min(1, scrollProgress));

    const speedAttr = parseFloat(el.dataset.pspeed);
    const speed = isNaN(speedAttr) ? 1 : speedAttr;

    // Get scale from data attribute (default to 1)
    let scale = parseFloat(el.dataset.pscale) || 1;

    // Modified translateY to start below and end above
    const translateY = (1 - 2 * clampedProgress) * speed;

    // Apply both translate and scale
    el.style.transform = `translateY(${translateY}px) scale(${scale})`;
    el.style.transformOrigin = 'center center';
  });
}

// Run on scroll
window.addEventListener('scroll', updateParallax);

// Run on page load
window.addEventListener('DOMContentLoaded', updateParallax);

// Run once immediately (in case DOM is already loaded)
updateParallax();